__turbopack_context__.v({
  "button": "quantity-stepper-module-scss-module__41aTqG__button",
  "root": "quantity-stepper-module-scss-module__41aTqG__root",
  "value": "quantity-stepper-module-scss-module__41aTqG__value",
});
